import { Injectable, OnDestroy } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { map, Observable, Subscription, take, tap } from "rxjs";
import { AppState, getState } from "../state/app.state";

@Injectable({
    providedIn: 'root'
})
export class PageGuard  implements OnDestroy {
    private subs: Subscription[] = [];
    private state: AppState

    constructor(private store: Store<AppState>, private router: Router) {
        this.subs.push(getState(store).subscribe(state => this.state = state));
    }

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if ((this.state?.kiosk?.websiteStarted ?? false) == false) //redirect automatically to home page when do refresh
             this.router.navigate(["app-login"]);

        if ((this.state?.transactionInfo?.hospitalisationRegistered ?? false) == true) //redirect automatically to home page when back on light page
             this.router.navigate(["app-login"]);

        return true;
    }
}